// extracted by mini-css-extract-plugin
module.exports = {"list":"Catalog_list__f2kAJ","card":"Catalog_card__1_FuZ","btns":"Catalog_btns__3nUnV","button":"Catalog_button__VxyfS","loader":"Catalog_loader__2sKuP"};